import Card from '@/models/Card';

const cardPool = [
  new Card('img/cards/team-anna_gyuris.jpeg', 'Anna Gyuris', 'Content Manager'),
  new Card('img/cards/team-christopher_parotat.jpg', 'Christopher Parotat', 'Senior Software Developer'),
  new Card('img/cards/team-david_hermann.jpg', 'David Hermann', 'Senior Portal Manager'),
  new Card('img/cards/team-julian_weber.jpg', 'Julian Weber', 'CEO, Founder'),
  new Card('img/cards/team-markus_scherping.jpg', 'Markus Scherping', 'Senior SEA Manager'),
  new Card('img/cards/team-niklas_habermann.jpeg', 'Niklas Habermann', 'Senior Category Manager'),
  new Card('img/cards/team-simon_willkomm.jpg', 'Simon Willkomm', 'Senior Product Owner'),
  new Card('img/cards/team-stefan_bauer.jpg', 'Stefan Bauer', 'Senior Software Developer'),
  new Card('img/cards/team-thea_weiland.jpg', 'Thea Weiland', 'Personal & Office Management'),
  new Card('img/cards/logo-blue.png', '', ''),
  new Card('img/cards/logo-gray.png', '', ''),
  new Card('img/cards/logo-green.png', '', ''),
  new Card('img/cards/logo-orange.png', '', ''),
  new Card('img/cards/logo-purple.png', '', ''),
  new Card('img/cards/logo-red.png', '', ''),
  new Card('img/cards/logo-yellow.png', '', ''),
  new Card('img/cards/office-0.jpg', 'Brainstorming', ''),
  new Card('img/cards/office-1.jpg', 'Breakfast', ''),
  new Card('img/cards/office-2.jpg', 'Meeting', ''),
  new Card('img/cards/office-3.jpg', 'Workshop', ''),
  new Card('img/cards/office-4.jpg', 'Teamwork', ''),
  new Card('img/cards/office-5.jpg', 'Table Soccer', 'Our friendly office competition'),
  new Card('img/cards/berlin-1.jpeg', 'Berlin', 'Beautiful by night'),
  new Card('img/cards/berlin-2.jpeg', 'Fernsehturm', 'The Berlin TV Tower'),
  new Card('img/cards/berlin-0.jpeg', 'Brandenburger Tor', 'Berlin\'s Brandenburg Gate'),
  new Card('img/cards/founders.jpg', 'The Founders', ''),
  new Card('img/cards/olga.png', 'Olga', 'Our most successful ad-persona'),
  new Card('img/cards/clouds.jpeg', 'The Cloud', 'Find the best solution for your needs'),
  new Card('img/cards/emu.jpg', 'Emu', ''),
  new Card('img/cards/ara.jpeg', 'Ara', ''),
  new Card('img/cards/dove.jpeg', 'Dove', ''),
  new Card('img/cards/code.jpeg', 'Code', ''),
  new Card('img/cards/coffee.jpeg', 'Coffee', ''),
  new Card('img/cards/management.jpeg', 'Management', ''),
  new Card('img/cards/notes.jpeg', 'Notes', ''),
];

export default cardPool;
